// extracted by mini-css-extract-plugin
export var pillWrapper = "_p6-0";
export var showOverflow = "_p6-1";